module.exports = __webpack_public_path__ + "static/media/vessel2.54d6095f.svg";